export default "__VITE_ASSET__BUxdXWoe__"